module.exports = __webpack_public_path__ + "img/connect-6.7455a3e0.svg";